import { required, minLength, minValue, maxValue } from 'vuelidate/lib/validators'

// import Foerderung from './Foerderung'

export default () => {
  let maxYear = new Date().getFullYear() || 2025

  return {
    organisationseinheit: {
      name: { required, minLength: minLength(1) }
    },
    namePreis: { required, minLength: minLength(1) },
    preisBezeichnung: {
      name: { required, minLength: minLength(1) }
    },
    verleihungsJahr: { required, minValue: minValue(1409), maxValue: maxValue(maxYear) },
    preisTraeger: {
      name: { required, minLength: minLength(1) }
    }
  }
}



// WEBPACK FOOTER //
// ./src/validation/Preis.js